const S3_HOST = /^([a-z0-9.-]+\.)?s3([.-][a-z0-9-]+)?\.amazonaws\.com$/i

export function isS3Url(url) {
    try {
        const parsed = new URL(url)
        return parsed.protocol === 'https:' && S3_HOST.test(parsed.hostname)
    } catch (err) {
        return false
    }
}

/**
 * Stage private-bucket CORS allows the deployed SPA and localhost:8080/8081.
 * `npm run stage` is http://127.0.0.1:8888, so browser calls to S3 are blocked.
 * In dev, send those calls through the webpack proxy instead.
 */
export function devS3Url(url) {
    if (process.env.NODE_ENV !== 'development' || !isS3Url(url)) return url
    return `/__s3_dev_proxy?target=${encodeURIComponent(url)}`
}
